import * as mediaContentsApi from '@/api/mediaContents';
import * as waitMediaContentsApi from '@/api/waitMediaContents';

export default {
    namespaced: true,
    state: {
        searchMediaKeyword: '',
        searchWaitMediaKeyword: '',
        mediaContents: [],
        waitMediaContents: [],
    },
    getters: {
        searchMediaKeyword: state => state.searchMediaKeyword,
        searchWaitMediaKeyword: state => state.searchWaitMediaKeyword,
        mediaContents: state => state.mediaContents,
        waitMediaContents: state => state.waitMediaContents,
    },
    mutations: {
        setSearchMediaKeyword(state, payload) {
            state.searchMediaKeyword = payload;
        },
        setSearchWaitMediaKeyword(state, payload) {
            state.searchWaitMediaKeyword = payload;
        },
        setMediaContents(state, payload) {
            state.mediaContents = payload;
            state.searchKeyword = '';
        },
        setWaitMediaContents(state, payload) {
            state.waitMediaContents = payload;
            state.searchWaitMediaKeyword = '';
        },
    },
    actions: {
        async fetchMediaContents({ getters, commit }) {
            try {
                const params = {
                    only_selectable: 1,
                    ...getters.searchMediaKeyword && { keyword: getters.searchMediaKeyword },
                };
                const response = await mediaContentsApi.fetchMediaContents(params);
                commit('setMediaContents', response.data.data);
            } catch (e) {
                commit('setMediaContents', []);
            }
        },

        async fetchWaitMediaContents({ getters, commit }) {
            try {
                const params = {
                    only_selectable: 1,
                    ...getters.searchWaitMediaKeyword && { keyword: getters.searchWaitMediaKeyword },
                };
                const response = await waitMediaContentsApi.fetchWaitMediaContents(params);
                commit('setWaitMediaContents', response.data.data);
            } catch (e) {
                commit('setWaitMediaContents', []);
            }
        },
    },
};
